import { Col, Row } from 'reactstrap'
import { H6 } from '../../../../../AbstractElements'
import { useAuth } from '../../../../../hooks/useAuth'
import { useTranslation } from 'react-i18next'

const ProfileMail = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  // Datos del usuario para mostrar
  const profileData = [
    {
      icon: 'envelope',
      title: t("Email"),
      detail: user?.email || t("No disponible")
    },
    {
      icon: 'user',
      title: t("Usuario"),
      detail: user?.username || user?.email || t("No disponible")
    }
  ];

  return (
    <Col sm="6" lg="4" className="order-sm-1 order-xl-0">
      <Row>
        {profileData.map((data, i) => (
          <Col md="6" key={i}>
            <div className="ttl-info text-start">
              <H6>
                <i className={`fa fa-${data.icon}`} /> {data.title}
              </H6>
              <span>{data.detail}</span>
            </div>
          </Col>
        ))}
      </Row>
    </Col>
  )
}

export default ProfileMail